import usePackageViewsTierProgression from 'loyalty/hooks/usePackageViewsTierProgression'
import useUserTierProgress from 'loyalty/hooks/useUserTierProgress'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import TierProgressionBanner from './TierProgressionBanner'
import { EmptyArray } from 'lib/array/arrayUtils'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'

interface Props {
  className?: string
  offer: App.HotelOffer | App.VillaOffer | App.BundleOffer | undefined
  packageViews?: Array<App.OfferPackageOptionView>
  checkoutDate?: string
}

function FlashTierProgressionPanel({ className, offer, packageViews = EmptyArray, checkoutDate }: Props) {
  const {
    showTierProgressionBanner,
    lowestUnlockableTier,
    lowestUnlockableTierName,
    highestUnlockableTier,
    highestUnlockableTierName,
    hasMultipleTierJumps,
    isLoading,
    statusReviewDate,
  } = usePackageViewsTierProgression({
    packageViews,
    offer,
    checkoutDate,
    skip: packageViews.length === 0,
  })

  const isTierProgressionExperimentEnabled = !!useOptimizelyExperiment(
    OptimizelyExperiments.croTierProgressionOfferPage,
    showTierProgressionBanner && !isLoading,
  )

  const { creditsNeeded, nightsNeeded } = useUserTierProgress()

  if (!isTierProgressionExperimentEnabled || isLoading || !showTierProgressionBanner) {
    return null
  }

  return (
    <TierProgressionBanner
      className={className}
      lowestUnlockableTier={lowestUnlockableTier}
      lowestUnlockableTierName={lowestUnlockableTierName}
      highestUnlockableTier={highestUnlockableTier}
      highestUnlockableTierName={highestUnlockableTierName}
      hasMultipleTierJumps={hasMultipleTierJumps}
      statusCreditsNeeded={creditsNeeded}
      nightsNeeded={nightsNeeded}
      statusReviewDate={statusReviewDate}
      checkoutDate={checkoutDate}
    />
  )
}

export default withMountGuard(() => {
  return useAppSelector(getIsCurrentRegionUserLoyaltyRegion)
})(FlashTierProgressionPanel)
